interface LoaderProps {
  message?: string;
}

/**
 * نیم‌رخ خودرو، رو به چپ (جهت پیشروی در RTL). چرخ‌ها گروه جدا (car-wheel) دارند تا بچرخند:
 * در پیش‌بارگذار هیرو با پیشرفت واقعی، این‌جا با انیمیشن.
 */
export function CarGlyph({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 100 33" className={className} fill="currentColor" aria-hidden="true">
      <path
        fillRule="evenodd"
        d="M4 24.5C4 21 5.5 18.6 9.5 17.8L27 15.2C31.5 10.5 37.5 7 46 6.6L61 6.6C69.5 6.6 77 9.6 84 14L92.5 15.6C95 16.1 96 17.8 96 20.5L96 24C96 25.3 95.2 26 94 26L83 26A8 8 0 0 0 67 26L33 26A8 8 0 0 0 17 26L6 26C4.8 26 4 25.4 4 24.5ZM33 14.6C36.5 11.2 41 9.1 46.5 8.9L53.5 8.9L53.5 14.6ZM56 8.9L61 8.9C67.5 8.9 73.5 11 78.5 14.6L56 14.6Z"
      />
      {[25, 75].map((cx) => (
        <g key={cx} className="car-wheel" fill="none" stroke="currentColor">
          <circle cx={cx} cy={26} r={4.9} strokeWidth={2.2} />
          <path d={`M${cx - 4} 26h8M${cx} 22v8`} strokeWidth={1.2} />
        </g>
      ))}
    </svg>
  );
}

/** بارگذاری صفحه‌ها (بی‌درصد): همان خودرو جاده را از شروع تا پایان می‌رود و از نو */
export default function Loader({ message = "در حال بارگذاری..." }: LoaderProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-[50vh] flex-col items-center justify-center gap-4"
    >
      <div className="loader-road" aria-hidden>
        <CarGlyph className="loader-car" />
      </div>
      <p className="text-muted-foreground text-sm">{message}</p>
    </div>
  );
}
